import { get, put, Delete, post } from '../axios'
import axios from "axios";

// 波形标签-左侧菜单列表
export const waveformDictCode = dictCode => get(`/web/waveform/list/waveformGroup/${dictCode}`);

// 波形标签-列表
export const waveformList = params => get(`/web/waveform/tag/list`,params);

// 波形标签-详情
export const waveformView = id => get(`/web/waveform/tag/get/${id}`);

// 波形标签-新增
export const waveformAdd = params => post(`/web/waveform/tag/add`, params);

// 波形标签-编辑
export const waveformUpdate = params => put(`/web/waveform/tag/update`,params);

// 波形标签-删除
export const waveformDelete = ids => Delete(`/web/waveform/tag/delete/${ids}`);

// 波形标签-查看
export const waveformRelation = params => get(`/web/waveform/load/wave/viewRelation`, params);

// 波形标签-上传npy文件
export const waveformNpyResolve = params => post(`/web/waveform/tag/npyResolve`, params);

// 波形标签-查看-NPY文件上传数据
export const waveformNpyResolveList = params => get(`/web/waveformNpyResolve/list`, params);

// 波形标签-查看-NPY文件上传数据-查看波形
export const waveformNpyResolveView = id => get(`/web/waveformNpyResolve/loadView/${id}`);

// 波形标签-查看-NPY文件上传数据-下载（文件流）
export const waveformNpyObsDownloadStream = obsUrl => {
  return axios.get(`/web/waveformNpyResolve/obs/download`, {
    params: obsUrl,
    responseType: 'blob', // 关键：指定响应类型为blob
    headers: {
      'X-Download': 'true' // 添加自定义头部标识文件下载
    }
  });
};

// 波形关联标签-NPY文件上传数据-迁移
export const waveformNpyResolveUpdate = params => put(`/web/waveformNpyResolve/relatedNpy/update`, params);

// 波形关联标签-关联网关数据-下载（文件流）
export const waveformObsDownloadStream = obsUrl => {
  return axios.get(`/web/waveform/obs/download`, {
    params: obsUrl,
    responseType: 'blob', // 关键：指定响应类型为blob
    headers: {
      'X-Download': 'true' // 添加自定义头部标识文件下载
    }
  });
};
// 标签文件下载
export const waveformNpyResolveEExecDownZipTask = params => post(`/web/waveformNpyResolve/relatedNpy/execDownZipTask`, params);

